import { normalizeIpId } from './myIpService';

const PREFIX = 'roboneo:ip-project-handoff:';

interface MyIpProjectHandoff {
  projectId: string;
  roomId: string;
  ipId: string;
  ipIds: string[];
  scopeKey: string;
  canvasId?: string;
}

/** 画布交接与 Team Studio 加载身份共用账号空间键，避免个人版 clientOId 空值对不上。 */
export function getMyIpProjectHandoffScopeKey(
  uid: string | undefined,
  clientOId: string | number | null | undefined,
  clientId: string | undefined,
  oversea: boolean | undefined,
): string {
  return JSON.stringify([uid, clientOId ?? 0, clientId, oversea]);
}

function readHandoff(roomId: string): MyIpProjectHandoff | null {
  try {
    const data = JSON.parse(sessionStorage.getItem(`${PREFIX}${roomId}`) || 'null');
    if (!data || data.roomId !== roomId || typeof data.projectId !== 'string' || typeof data.scopeKey !== 'string') {
      return null;
    }
    const rawIds = Array.isArray(data.ipIds) && data.ipIds.length ? data.ipIds : [data.ipId];
    const ipIds = rawIds.map((id: unknown) => normalizeIpId(id));
    if (!ipIds.length) return null;
    return {
      projectId: data.projectId,
      roomId: data.roomId,
      ipId: ipIds[0],
      ipIds,
      scopeKey: data.scopeKey,
      canvasId: typeof data.canvasId === 'string' ? data.canvasId : undefined,
    };
  } catch {
    return null;
  }
}

/** 只记录由真实 create-from 或已校验创建来源授权的目标画布，单独构造 URL 不会触发自动写画布。 */
export function rememberMyIpProjectHandoff(
  projectId: string,
  roomId: string,
  ipId: string | string[],
  scopeKey: string,
  canvasId?: string,
): void {
  const ipIds = [...new Set((Array.isArray(ipId) ? ipId : [ipId]).map(normalizeIpId))];
  if (!ipIds.length) throw new Error('Invalid IP identifier');
  sessionStorage.setItem(`${PREFIX}${roomId}`, JSON.stringify({
    projectId, roomId, ipId: ipIds[0], ipIds, scopeKey, canvasId,
  }));
}

/** 检查项目/房间/IP/账号空间完全一致；损坏或其他账号的数据不能作为写入授权。 */
export function hasMyIpProjectHandoff(projectId: string, roomId: string, ipId: string, scopeKey: string, canvasId?: string): boolean {
  const data = readHandoff(roomId);
  return Boolean(data && data.projectId === projectId && data.ipIds.includes(ipId) && data.scopeKey === scopeKey
    && (data.canvasId === undefined || data.canvasId === canvasId));
}

/** 读取本次授权要落入画布的全部 IP；损坏缓存返回空。 */
export function readMyIpProjectHandoffIpIds(roomId: string): string[] {
  return readHandoff(roomId)?.ipIds ?? [];
}

/** 仅在节点和引用均成功保存后消费授权，刷新不会重建用户随后删除的节点。 */
export function completeMyIpProjectHandoff(roomId: string): void {
  sessionStorage.removeItem(`${PREFIX}${roomId}`);
}
